/* global __DEV__ */

import sagas from 'sagas'
import * as reducers from 'reducers'
import createSagaMiddleware from 'redux-saga'
import { createStore, applyMiddleware, combineReducers } from 'redux'

export default configureStore

function configureStore (initialState) {
  const sagaMiddleware = createSagaMiddleware()

  let createStoreWithMiddleware

  if (__DEV__) {
    createStoreWithMiddleware = applyMiddleware(
      require('redux-logger')(),
      sagaMiddleware
    )(createStore)
  } else {
    createStoreWithMiddleware = applyMiddleware(sagaMiddleware)(createStore)
  }

  const reducer = combineReducers(reducers)
  let store

  if (__DEV__) {
    store = createStoreWithMiddleware(
      reducer,
      initialState,
      window.devToolsExtension && window.devToolsExtension()
    )
  } else {
    store = createStoreWithMiddleware(
      reducer,
      initialState
    )
  }

  sagaMiddleware.run(sagas)
  return store
}



// WEBPACK FOOTER //
// ./src/configs/configureStore.js